import React from 'react'
import cx from 'classnames'

import s from './FooterSocials.scss'


const socials = [
  {
    name: 'facebook',
    link: 'https://www.facebook.com/scentbird',
    ariaLabel: 'Facebook',
  },
  {
    name: 'twitter',
    link: 'https://www.twitter.com/scentbird',
    ariaLabel: 'Twitter',
  },
  {
    name: 'pinterest',
    link: 'https://www.pinterest.com/scentbird/',
    ariaLabel: 'Pinterest',
  },
  {
    name: 'instagram',
    link: 'https://instagram.com/scentbird/',
    ariaLabel: 'Instagram',
  },
]

const FooterSocials = () => (
  <div className={s.socials}>
    {
      socials.map(({ name, link, ariaLabel }, index) => (
        <a
          key={index}
          className={cx(s.social, s[name])}
          href={link}
          rel="noopener noreferrer nofollow"
          target="_blank"
          aria-label={ariaLabel}
        />
      ))
    }
  </div>
)


export default FooterSocials
